// extracted by mini-css-extract-plugin
export default {"slider":"styles_slider__fhn4O","track":"styles_track__hJHxx","filled":"styles_filled__oIfXf","thumb":"styles_thumb__RoKmA"};